import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src760788307/src/mds-docs/gatsby-theme-mds/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Preview = makeShortcode("Preview");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`An avatar consists of the display picture of the entity that it represents i.e. a user. In case a display picture is not available, it consists of a colored background and the initials of the name that it represents. And if somehow the initials can’t be fetched, a fallback glyph is used.`}</p>
    <br />
    <h4 {...{
      "id": "types"
    }}>{`Types`}</h4>
    <br />
    <h5 {...{
      "id": "appearances"
    }}>{`Appearances`}</h5>
    <p>{`Avatar comes in 9 Appearances -`}</p>
    <Preview name='avatar-variants-appearance' mdxType="Preview" />
    <h5 {...{
      "id": "sizes"
    }}>{`Sizes`}</h5>
    <p>{`Avatar comes in 2 sizes -`}</p>
    <Preview name='size' mdxType="Preview" />
    <br />
    <h4 {...{
      "id": "usage"
    }}>{`Usage`}</h4>
    <br />
    <h5 {...{
      "id": "color-assignment"
    }}>{`Color Assignment`}</h5>
    <p>{`The background colors to be used in the avatars should be generated dynamically such that at the time of its creation a random color (from the available options) is assigned. Once assigned, the color should stay the same as long as that particular avatar is in use.`}</p>
    <p>{`For example, an avatar generated for a user - Franklin Clinton, can look like following and it will look the same wherever it is used.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "14.930555555555555%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAATUlEQVQI14WOUQrAIAxDe//LeLL9CZJ0mNHimAzFjwfhUdIYSQcgkp2kZoYXak1m96MP7/aWrQ7Rmm5JVylJ5HCbx9lhx4Xu38LIh4UPBvzp5zMDuu4AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "avatar 1",
          "title": "avatar 1",
          "src": "/static/d49e17896d9f16cab29dc90f765b96ce/3cbba/avatar-1.png",
          "srcSet": ["/static/d49e17896d9f16cab29dc90f765b96ce/7fc1e/avatar-1.png 288w", "/static/d49e17896d9f16cab29dc90f765b96ce/a5df1/avatar-1.png 576w", "/static/d49e17896d9f16cab29dc90f765b96ce/3cbba/avatar-1.png 1152w", "/static/d49e17896d9f16cab29dc90f765b96ce/4c487/avatar-1.png 1280w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <br />
    <h5 {...{
      "id": "displaying-name"
    }}>{`Displaying Name`}</h5>
    <p>{`Since avatars can only show images or initials, there should be an option to show the full name of an entity. This can be achieved by `}<strong parentName="p">{`hovering`}</strong>{` over on an avatar which displays a tooltip containing the full name.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "14.930555555555555%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAa0lEQVQI122OQQqAMBAD++/iWxTEg3jVo17sI9qfdCM00sXKHroQCCE7xAF4RIQACgA21Uxypl6MZEpqa/b1rcqXPa7BbKn5+nyFwMl7jsPA8741sx3jleF6C3+gCI9957JtnNdVfe4A7cIX4GzjRL23hVgAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "avatar 2",
          "title": "avatar 2",
          "src": "/static/3da6ae043add68d9bb9acc9f2a5c7dce/3cbba/avatar-2.png",
          "srcSet": ["/static/3da6ae043add68d9bb9acc9f2a5c7dce/7fc1e/avatar-2.png 288w", "/static/3da6ae043add68d9bb9acc9f2a5c7dce/a5df1/avatar-2.png 576w", "/static/3da6ae043add68d9bb9acc9f2a5c7dce/3cbba/avatar-2.png 1152w", "/static/3da6ae043add68d9bb9acc9f2a5c7dce/4c487/avatar-2.png 1280w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <br />
    <h5 {...{
      "id": "number-of-avatars"
    }}>{`Number of avatars`}</h5>
    <p>{`Avatars can be used individually or as a group if required. For example - If an activity is being done by 4 users, you would want to use the avatar group for the same.`}</p>
    <p>{`To be specific, an avatar can be used in 3 ways as -`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Single entity
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "14.930555555555555%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAATUlEQVQI14WOUQrAIAxDe//LeLL9CZJ0mNHimAzFjwfhUdIYSQcgkp2kZoYXak1m96MP7/aWrQ7Rmm5JVylJ5HCbx9lhx4Xu38LIh4UPBvzp5zMDuu4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "avatar 1",
              "title": "avatar 1",
              "src": "/static/d49e17896d9f16cab29dc90f765b96ce/3cbba/avatar-1.png",
              "srcSet": ["/static/d49e17896d9f16cab29dc90f765b96ce/7fc1e/avatar-1.png 288w", "/static/d49e17896d9f16cab29dc90f765b96ce/a5df1/avatar-1.png 576w", "/static/d49e17896d9f16cab29dc90f765b96ce/3cbba/avatar-1.png 1152w", "/static/d49e17896d9f16cab29dc90f765b96ce/4c487/avatar-1.png 1280w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Two entities
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "14.930555555555555%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXklEQVQI142OwQmAQBADt2Yb8Gk/lmEXVuAJ3mmyYOTEBREf98hjs5MQI+kARPIkqdDtgQKhrSw61iQCQvxebM0+nluUfaF6O1zFs8ap0zz0Yt4Fd/2x0WHNC1PbwguHJOjXnyxz8QAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "avatar 3",
              "title": "avatar 3",
              "src": "/static/24383184e4f5dbc0f07986c580407ef9/3cbba/avatar-3.png",
              "srcSet": ["/static/24383184e4f5dbc0f07986c580407ef9/7fc1e/avatar-3.png 288w", "/static/24383184e4f5dbc0f07986c580407ef9/a5df1/avatar-3.png 576w", "/static/24383184e4f5dbc0f07986c580407ef9/3cbba/avatar-3.png 1152w", "/static/24383184e4f5dbc0f07986c580407ef9/4c487/avatar-3.png 1280w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`More than 2 entities
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "14.930555555555555%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAYElEQVQI142OwQmAMBRDu6ijOYZH0R0cQxRRP23ywXixRUTEQy4v4ZFA0gGI5EFSORdThMm2WTATCBEo3S3HxTxk2XOUECWXhq1TW1cam14Lk/xFeHeEXw/XSWm3wr4ennTN6LeNReFaAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "avatar 4",
              "title": "avatar 4",
              "src": "/static/6f61742b1379b61858e630ab030e4787/3cbba/avatar-4.png",
              "srcSet": ["/static/6f61742b1379b61858e630ab030e4787/7fc1e/avatar-4.png 288w", "/static/6f61742b1379b61858e630ab030e4787/a5df1/avatar-4.png 576w", "/static/6f61742b1379b61858e630ab030e4787/3cbba/avatar-4.png 1152w", "/static/6f61742b1379b61858e630ab030e4787/4c487/avatar-4.png 1280w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
In order to show the additional entities that are not visible upfront, a popover having the list of full names of those additional entities is shown on click.
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAxklEQVQY043QsWqDUBSAYR/IxcmOFopkLl2CWx8rIhmEDnbtW3Rpl2QxIIpbVQgIx+Pl/sWAxUoCGS5c7jl8/FxHVXUYBlTVqirzmd6MWn6kpjh+IHnBCGDt33yxb2fDmS+rBWQQJuF0/uZ998rn/o2v44GqLBGRm6iz1P+BIlMOVVnz/LLlabPhMQiIooiu6zDGLME7Ci8g5KecB9/H8zxc1yUMQ5qmuYBz6brw9h8aQ9u2pGlKkiTEcUyWZfR9zziOVwt/ASCubgqWh6U1AAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "avatar 5",
              "title": "avatar 5",
              "src": "/static/0fa62a73201ee56d6eef81d2ab4c9f72/3cbba/avatar-5.png",
              "srcSet": ["/static/0fa62a73201ee56d6eef81d2ab4c9f72/7fc1e/avatar-5.png 288w", "/static/0fa62a73201ee56d6eef81d2ab4c9f72/a5df1/avatar-5.png 576w", "/static/0fa62a73201ee56d6eef81d2ab4c9f72/3cbba/avatar-5.png 1152w", "/static/0fa62a73201ee56d6eef81d2ab4c9f72/4c487/avatar-5.png 1280w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      